export const TIMING_FUNCTIONS = {
  linear: {
    p1: [0.5, 0.5],
    p2: [0.5, 0.5],
  },
  ease: {
    p1: [0.25, 0.1],
    p2: [0.25, 1],
  },
  'ease-in': {
    p1: [0.42, 0],
    p2: [1, 1],
  },
  'ease-out': {
    p1: [0, 0],
    p2: [0.58, 1],
  },
  'ease-in-out': {
    p1: [0.42, 0],
    p2: [0.58, 1],
  },
  'ease-mega': {
    label: 'ease (supercharged)',
    p1: [0.44, 0.21],
    p2: [0, 1],
  },
  'ease-in-mega': {
    label: 'ease-in (supercharged)',
    p1: [0.75, 0],
    p2: [1, 1],
  },
  'ease-out-mega': {
    label: 'ease-out (supercharged)',
    p1: [0.215, 0.61],
    p2: [0.355, 1],
  },
  'ease-in-out-mega': {
    label: 'ease-in-out (supercharged)',
    p1: [0.645, 0.045],
    p2: [0.355, 1],
  },
  overshot: {
    label: 'overshot',
    p1: [0.325, 0],
    p2: [0.7, 1.25],
  },
  '3d-button-equilibrium': {
    label: '3D Button, equilibrium',
    p1: [0.3, 0.7],
    p2: [0.4, 1],
    secret: true,
  },
  '3d-button-springy': {
    label: '3D button, springy',
    p1: [0.3, 0.7],
    p2: [0.4, 1.25],
    secret: true,
  },
};
